import { Crown } from 'lucide-react'
import { Link } from 'react-router-dom'

function FeatureLimitCard({ message }) {
  return (
    <section className="feature-limit-card" role="alert">
      <div>
        <span><Crown size={18} /></span>
        <div>
          <h2>免费额度已用完</h2>
          <p>{message || '每月免费额度已用完，升级 VIP 后可获得每日刷新额度，并解锁更完整的分析报告。'}</p>
        </div>
      </div>
      <Link className="primary-button" to="/vip">
        <Crown size={16} />
        查看 VIP 权益
      </Link>
    </section>
  )
}

export default FeatureLimitCard
